(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('RaciDeleteController',RaciDeleteController);

    RaciDeleteController.$inject = ['$uibModalInstance', 'entity', 'Raci'];

    function RaciDeleteController($uibModalInstance, entity, Raci) {
        var vm = this;

        vm.raci = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Raci.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
